import { render, staticRenderFns } from "./bannerPage.vue?vue&type=template&id=11c1416b&scoped=true&"
import script from "./bannerPage.vue?vue&type=script&lang=js&"
export * from "./bannerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c1416b",
  null
  
)

export default component.exports